/* eslint-disable react/prop-types */
import { Accordion, AccordionItem as Item } from "@szhsin/react-accordion";
import chevronDown from "../assets/chevron-down.svg";
import styles from "../styles.module.css";
import '../output.css';
import { useState } from "react";
/**
 * @type {React.ExoticComponent<import('@szhsin/react-accordion').AccordionItemProps>}
 */
const AccordionItem = ({ header, ...rest  }) => (
  <Item
    {...rest}
    header={
      <>
        {header}
        <img className={styles.chevron} src={chevronDown} alt="Chevron Down" />
      </>
    }
    className={styles.item}
    buttonProps={{
      className: ({ isEnter }) =>
        `${styles.itemBtn} ${isEnter && styles.itemBtnExpanded}`,
    }}
    contentProps={{ className: styles.itemContent }}
    panelProps={{ className: styles.itemPanel }}
  />
);

function Desc({ desc }) {
  return (
    <ul className="desc">
      <span>{desc?.h1}</span>

      {/* Especificaciones de bicicletas */}
      {desc?.peso && <li>Peso: {desc.peso}</li>}
      {desc?.tenedor && <li>Tenedor: {desc.tenedor}</li>}
      {desc?.tipoDeMarco && <li>Tipo de Marco: {desc.tipoDeMarco}</li>}
      {desc?.tamañoDelMarco && <li>Tamaño del Marco: {desc.tamañoDelMarco}</li>}
      {desc?.frenos && <li>Frenos: {desc.frenos}</li>}
      {desc?.grupo && <li>Grupo: {desc.grupo}</li>}
      {desc?.manubrio && <li>Manubrio: {desc.manubrio}</li>}
      {desc?.marco && <li>Marco: {desc.marco}</li>}
      {desc?.llanta_delantera && <li>Llanta Delantera: {desc.llanta_delantera}</li>}
      {desc?.llanta_trasera && <li>Llanta Trasera: {desc.llanta_trasera}</li>}
      {desc?.cambiador && <li>Cambiador: {desc.cambiador}</li>}
      {desc?.descarrilador_delantero && <li>Descarrilador Delantero: {desc.descarrilador_delantero}</li>}
      {desc?.descarrilador_trasero && <li>Descarrilador Trasero: {desc.descarrilador_trasero}</li>}
      {desc?.platos_vielas && <li>Platos y Bielas: {desc.platos_vielas}</li>}
      {desc?.cassette && <li>Cassette: {desc.cassette}</li>}
      {desc?.cadena && <li>Cadena: {desc.cadena}</li>}
      {desc?.ejes && <li>Ejes: {desc.ejes}</li>}
      {desc?.vastago_manubrio && <li>Vástago del Manubrio: {desc.vastago_manubrio}</li>}
      {desc?.tija_sillin && <li>Tija del Sillín: {desc.tija_sillin}</li>}
      {desc?.sillin && <li>Sillín: {desc.sillin}</li>}
      {desc?.rines && <li>Rines: {desc.rines}</li>}

      {/* Especificaciones de scooters */}
      {desc?.frame_material && <li>Material del Marco: {desc.frame_material}</li>}
      {desc?.net_weight && <li>Peso Neto: {desc.net_weight}</li>}
      {desc?.motor_power && <li>Potencia del Motor: {desc.motor_power}</li>}
      {desc?.battery_type && <li>Tipo de Batería: {desc.battery_type}</li>}
      {desc?.battery_capacity && <li>Capacidad de Batería: {desc.battery_capacity}</li>}
      {desc?.charger && <li>Cargador: {desc.charger}</li>}
      {desc?.range && <li>Autonomía: {desc.range}</li>}
      {desc?.charging_time && <li>Tiempo de Carga: {desc.charging_time}</li>}
      {desc?.max_speed && <li>Velocidad Máxima: {desc.max_speed}</li>}
      {desc?.tyre_type && <li>Tipo de Neumático: {desc.tyre_type}</li>}
      {desc?.brake_type && <li>Tipo de Freno: {desc.brake_type}</li>}
      {desc?.lights && <li>Luces: {desc.lights}</li>}
      {desc?.box_size && <li>Tamaño de Caja: {desc.box_size}</li>}
      {desc?.board_material && <li>Material del Tablero: {desc.board_material}</li>}
      {desc?.max_load && <li>Carga Máxima: {desc.max_load}</li>}
      {desc?.voltage && <li>Voltaje: {desc.voltage}</li>}
      {desc?.max_climbing_angle && <li>Ángulo Máximo de Ascenso: {desc.max_climbing_angle}</li>}
      {desc?.motor_drive && <li>Tracción del Motor: {desc.motor_drive}</li>}
    </ul>
  );
}


export default function AccordionBike({ data, setSize }) {
  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontFamily: 'Arial, sans-serif',
  };

  const cellStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'center',
  }; 


  return (
    <div className={styles.container} style={{width: "440px",  borderRadius: "5px"}} >
      <div className={styles.accordion} style={{width: "400px"}}>
        {/* `transitionTimeout` prop should be equal to the transition duration in CSS */}
        <Accordion transition transitionTimeout={250}>
          <div style={{width: "100%"}}>
          <AccordionItem header="Características">
           <Desc desc={data?.description}></Desc>
          </AccordionItem>

          <AccordionItem header="Dimensiones">
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={cellStyle}>Tallas</th>
              </tr>
            </thead>
            <tbody>
              {data?.dimensions?.reduce((unique, dimension) => {
                if (!dimension) return unique;
                
                // Extraer el número inicial y el resto del texto
                const [, initialNum, restText] = dimension.toString()
                  .trim()
                  .match(/^(\d+)\s*(.*)$/i) || [null, '', ''];
                
                // Normalizar el resto del texto
                const normalizedRest = restText
                  .toLowerCase()
                  .replace(/menos\s+de/g, 'menos de')
                  .replace(/mas\s+de/g, 'mas de')
                  .replace(/\s*-\s*/g, ' - ')
                  .trim();
                
                // Buscar si ya existe una entrada con el mismo número inicial
                const existingIndex = unique.findIndex(item => {
                  const [, num] = item.toString()
                    .trim()
                    .match(/^(\d+)/) || [null, ''];
                  return num === initialNum;
                });

                // Si no existe el número, agregar la dimensión
                if (existingIndex === -1) {
                  unique.push(dimension);
                } else {
                  // Si existe el número y el resto del texto es "mas de" + un número mayor,
                  // reemplazar la entrada existente
                  const [, existingRest] = unique[existingIndex].toString()
                    .trim()
                    .match(/^(\d+)\s*(.*)$/i) || [null, '', ''];
                  
                  const existingHeight = parseFloat(existingRest.match(/\d+\.\d+/)?.[0] || '0');
                  const newHeight = parseFloat(restText.match(/\d+\.\d+/)?.[0] || '0');
                  
                  if (newHeight > existingHeight) {
                    unique[existingIndex] = dimension;
                  }
                }
                
                return unique;
              }, [])
              // Ordenar por número al inicio de la cadena
              .sort((a, b) => {
                const numA = parseInt(a.match(/\d+/)?.[0] || '0');
                const numB = parseInt(b.match(/\d+/)?.[0] || '0');
                return numA - numB;
              })
              .map((dimension, index) => (
                <tr key={index}>
                  <td style={cellStyle}>{dimension}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </AccordionItem>
          </div>
        </Accordion>
      </div>
    </div>
  );
}
